module.exports = __webpack_public_path__ + "img/manual_1.980f7290.png";